import { AwaitResponse } from '@general/js/utils/MockUtils';
import PublicSiteServices from '@general/js/services/MembershipStatus/MembershipStatusServicesMock';
import { getCurrentDate } from '@general/js/utils';
import { premiumCalculatorReferenceData } from '@/constants/MyCoverServicesMockApiData';
import PremiumCalculatorAbstractServices from './PremiumCalculatorAbstractServices';

export default class PremiumCalculatorServices extends PremiumCalculatorAbstractServices {
  /**
   * Mock reference data for premium calculator page
   */
  static getPremiumCalculatorReferenceData() {
    return AwaitResponse(JSON.parse(JSON.stringify(premiumCalculatorReferenceData).tokenSwap()));
  }

  /**
   * Return mock data for calculate premium from premium calculator page.
   *
   * @param {string} type string of calculated by type. if `"date"` is given, will return number otherwise would return mock date in yyyy-mm-dd format
   * @returns string data of result of mock api
   */
  static async calculatePremium(type = 'date', memberNumber, startDate) {
    let resMock;
    switch (type) {
      case 'amount':
        resMock = '2022-07-18';
        break;

      default:
        resMock = await PublicSiteServices.getProrataPrice(memberNumber, { params: { startDate, currentDate: getCurrentDate(), } });
        resMock = resMock.initialPayment;
        break;
    }
    return AwaitResponse(resMock);
  }
}
